{
  "senseResultats": "Ningún resultado con esta búsqueda.",
  "circuits": {
    "cerca": "Buscar circuito o servicio…",
    "general": "General",
    "usos_one": "Usado por {{count}} servicio",
    "usos_other": "Usado por {{count}} servicios",
    "unSolDefecte": "Solo puede haber uno: al marcarlo, el anterior deja de serlo.",
    "ajudaActiu": "Un circuito inactivo no se puede asignar a servicios nuevos.",
    "resumTemps": "Si nadie confirma, el aviso llega al último nivel ({{n}}) en el minuto {{min}}.",
    "ajudaConfirmacio": "El tiempo de confirmación del tipo de aviso se aplica dentro de cada nivel.",
    "canalNivell": "{{canal}} en el nivel {{n}}",
    "minut": "minuto {{min}}",
    "ultim": "último",
    "siNoConfirma": "Si nadie confirma en",
    "minutsPassa": "min por cada canal (se envían uno tras otro), pasa al nivel {{n}}",
    "crea": "Crear el circuito",
    "senseNom": "El circuito necesita un nombre."
  },
  "canals": {
    "titol": "Canales y tiempos",
    "reglesTemps": "Cómo se calcula cuándo se escala",
    "reglaConfirmacio": "Tiempo de confirmación del tipo de aviso",
    "reglaConfirmacioText": "Tiempo que se da a cada persona avisada para confirmar antes de reintentarlo. Se configura aquí, por tipo de aviso.",
    "reglaCircuit": "Espera de cada nivel del circuito",
    "reglaCircuitText": "Si nadie del nivel confirma en este tiempo, el aviso pasa al nivel siguiente. Es lo que decide cuándo se escala.",
    "veureCircuits": "Circuitos de escalado",
    "reglaDefecte": "Tiempo de escalado por defecto",
    "reglaDefecteText": "Solo se aplica a los niveles que no tienen una espera propia.",
    "veureConfiguracio": "Configuración general",
    "excepcions": "Servicios con canales propios",
    "defecte": "Por defecto: {{canals}}",
    "senseExcepcions": "Todos los servicios activos usan los canales por defecto ({{canals}}).",
    "servei": "Servicio",
    "edita": "Editar en Estructura",
    "obreServei": "Editar los canales de {{servei}} en Estructura"
  },
  "plantilles": {
    "cerca": "Buscar por título, código o tipo…",
    "totsTipus": "Todos los tipos",
    "altreTipus": "Otro tipo…",
    "textos": "Textos del mensaje",
    "incomplet": "Falta el título o el cuerpo",
    "ajudaIncomplet": "La versión en {{idioma}} no tiene título o cuerpo: quien tenga este idioma recibirá un mensaje vacío.",
    "insereixA": "Insertar la variable en «{{camp}}»",
    "ajudaVariables": "Se insertan donde tienes el cursor en «{{camp}}».",
    "camps": {
      "titol": "Título",
      "cos": "Cuerpo del correo",
      "cosPush": "Notificación push",
      "cosVeu": "Locución"
    },
    "valorDe": "Ejemplo de {{variable}}",
    "crea": "Crear la plantilla",
    "senseCodi": "Falta el código."
  },
  "importacio": {
    "passos": "Pasos de la importación",
    "pas": {
      "servei": "Servicio",
      "fitxer": "Fichero",
      "columnes": "Columnas",
      "revisa": "Revisar",
      "importa": "Importar"
    },
    "titolPas": {
      "servei": "1. ¿A qué servicio añades las personas?",
      "fitxer": "2. Elige el fichero Excel",
      "columnes": "3. Indica qué columna corresponde a cada campo",
      "revisa": "4. Revisa e importa"
    },
    "ajudaServei": "Cada servicio tiene su propia lista de personas a informar.",
    "triaServei": "Elige un servicio…",
    "llistaActual_one": "La lista actual de este servicio tiene {{count}} persona.",
    "llistaActual_other": "La lista actual de este servicio tiene {{count}} personas.",
    "sOmeten_one": "{{count}} (se omite)",
    "sOmeten_other": "{{count}} (se omiten)",
    "validacioLocal": "Recuento hecho en el navegador; pendiente de validar en el servidor.",
    "veureErrors_one": "Mostrar la fila con error",
    "veureErrors_other": "Mostrar las {{count}} filas con errores",
    "errorGeneric": "Fila {{fila}}: {{text}}",
    "mode_one": "Se añadirá {{count}} persona a la lista actual ({{actuals}}). No se quita ninguna: para quitar personas, hazlo desde la lista del servicio.",
    "mode_other": "Se añadirán {{count}} personas a la lista actual ({{actuals}}). No se quita ninguna: para quitar personas, hazlo desde la lista del servicio.",
    "revalida": "Volver a validar",
    "veureLlista": "Ver la lista del servicio",
    "obreServei": "Abrir el servicio en Estructura",
    "unAltre": "Importar otro fichero"
  },
  "informar": {
    "subtitol": "A quién se informa de cada servicio",
    "cerca": "Buscar servicio, área o departamento…",
    "obreServei": "Abrir en Estructura",
    "tria": "Elige un servicio para ver a quién se informa."
  }
}
